import byd from "../assets/img/logos/byd.png";
import stm from "../assets/img/logos/stm.png";
import fruconomy from "../assets/img/logos/fruconomy.png";
import apo from "../assets/img/logos/apo.png";
import euroaccent from "../assets/img/logos/euroaccent.png";
import nivaspet from "../assets/img/logos/nivaspet.webp";
import luxurydaydrive from "../assets/img/logos/Luxurydaydrive.png";
import stratus from "../assets/img/logos/stratus.webp";
import glg from "../assets/img/logos/glg.png";
import seven11 from "../assets/img/logos/711.webp";
import vipe from "../assets/img/logos/vipe.png";
import bantleads from "../assets/img/logos/bantleads.webp";
import maruldeaur from "../assets/img/logos/maruldeaur.webp";
import instruire from "../assets/img/logos/instruire.png";
import barbarosa from "../assets/img/logos/barbarosa.png";
import mambo from "../assets/img/logos/mambo 1.png";
import noidivin from "../assets/img/logos/noidivin.png";
import wuling from "../assets/img/logos/Wuling_logo_white.png";

import websites from "../assets/img/3ds/telework-6795505_1280.jpg";
import automation from "../assets/img/3ds/automatization.webp";
import mentorship from "../assets/img/3ds/mentorship.jpg";
import webDesign from "../assets/img/3ds/websites.jpg";
import platform from "../assets/img/3ds/sites.jpg";
import graphic from "../assets/img/3ds/graphic.jpg";

const project = (data) => ({ active: true, ...data });

const makeProjectGallery = (image, offset = 0) => {
   const pool = [websites, automation, mentorship, webDesign, platform, graphic];
   return [
      image,
      ...pool.slice(offset),
      ...pool.slice(0, offset),
   ].slice(0, 6);
};

export const projects = [
   project({
      id: "horizonauto",
      slug: "horizon-auto",
      link: "https://horizonauto.md/",
      imageUrl: byd,
      gallery: makeProjectGallery(byd, 0),
      sizeFactor: 0.7,
   }),
   project({
      id: "stm",
      slug: "stm-performance",
      link: "https://backup2.danielzota.site/",
      imageUrl: stm,
      gallery: makeProjectGallery(stm, 1),
      sizeFactor: 0.1,
      active: false,
   }),
   project({
      id: "fruconomy",
      slug: "fruconomy",
      link: "http://fuconomy.com",
      imageUrl: fruconomy,
      gallery: makeProjectGallery(fruconomy, 2),
      sizeFactor: 0.1,
      active: false,
   }),
   project({
      id: "apo",
      slug: "apo",
      link: "https://apo.md/",
      imageUrl: apo,
      gallery: makeProjectGallery(apo, 3),
      sizeFactor: 0.3,
   }),
   project({
      id: "euroaccent",
      slug: "euroaccent",
      link: "https://euroaccent.estate/",
      imageUrl: euroaccent,
      gallery: makeProjectGallery(euroaccent, 4),
      sizeFactor: 0.3,
   }),
   project({
      id: "nivaspet",
      slug: "nivaspet",
      link: "https://nivas.pet/",
      imageUrl: nivaspet,
      gallery: makeProjectGallery(nivaspet, 5),
      sizeFactor: 0.3,
   }),
   project({
      id: "daydriver",
      slug: "daydriver",
      link: "https://daydriver.pro/",
      imageUrl: luxurydaydrive,
      gallery: makeProjectGallery(luxurydaydrive, 0),
      sizeFactor: 0.1,
   }),
   project({
      id: "barbarosa",
      slug: "barbarosa-school",
      link: "http://barbarosa.school",
      imageUrl: barbarosa,
      gallery: makeProjectGallery(barbarosa, 1),
      sizeFactor: 0.1,
      active: false,
   }),
   project({
      id: "stratus",
      slug: "stratus-lofts",
      link: "http://stratuslofts.com",
      imageUrl: stratus,
      gallery: makeProjectGallery(stratus, 2),
      sizeFactor: 0.1,
      active: false,
   }),
   project({
      id: "glg",
      slug: "scoala-auto-glg",
      link: "https://scoalaautoglg.com/",
      imageUrl: glg,
      gallery: makeProjectGallery(glg, 3),
      sizeFactor: 0.3,
   }),
   project({
      id: "seven11",
      slug: "7eleven-agency",
      link: "http://7elevenagency.com",
      imageUrl: seven11,
      gallery: makeProjectGallery(seven11, 4),
      sizeFactor: 0.3,
      active: false,
   }),
   project({
      id: "vapeoutlet",
      slug: "vape-outlet",
      link: "https://www.vapeoutletonline.com/",
      imageUrl: vipe,
      gallery: makeProjectGallery(vipe, 5),
      sizeFactor: 0.3,
   }),
   project({
      id: "bantleads",
      slug: "bantleads",
      link: "https://bantleads.com/",
      imageUrl: bantleads,
      gallery: makeProjectGallery(bantleads, 0),
      sizeFactor: 0.3,
      active: false,
   }),
   project({
      id: "maruldeaur",
      slug: "marul-de-aur",
      link: "https://maruldeaur.md/",
      imageUrl: maruldeaur,
      gallery: makeProjectGallery(maruldeaur, 1),
      sizeFactor: 0.3,
   }),
   project({
      id: "mambolichior",
      slug: "mambo-lichior",
      link: "https://mambolichior.md/",
      imageUrl: mambo,
      gallery: makeProjectGallery(mambo, 2),
      sizeFactor: 0.3,
   }),
   project({
      id: "noidivin",
      slug: "noi-divin",
      link: "https://noidivin.md/",
      imageUrl: noidivin,
      gallery: makeProjectGallery(noidivin, 3),
      sizeFactor: 0.3,
   }),
   project({
      id: "insuladistractiilor",
      slug: "insula-distractiilor",
      link: "https://insuladistractiilor.md/",
      imageUrl: barbarosa,
      gallery: makeProjectGallery(barbarosa, 4),
      sizeFactor: 0.3,
   }),
   project({
      id: "wuling",
      slug: "wuling",
      link: "https://wuling.md/",
      imageUrl: wuling,
      gallery: makeProjectGallery(wuling, 5),
      sizeFactor: 0.7,
   }),
   project({
      id: "instruireautoplatform",
      slug: "instruire-auto-platform",
      link: "https://instruireauto.site/",
      imageUrl: instruire,
      gallery: makeProjectGallery(instruire, 2),
      sizeFactor: 0.3,
   }),
   project({
      id: "instruireautoschool",
      slug: "instruire-auto",
      link: "https://instruire-auto.md/",
      imageUrl: instruire,
      gallery: makeProjectGallery(instruire, 3),
      sizeFactor: 0.3,
   }),
];

export const getProjectBySlug = (slug) =>
   projects.find((project) => project.slug === slug);
